module.exports = __webpack_public_path__ + "images/cd0f91d3d0e87d22d13c60171cd0b955.svg";